import { CapoPlugin } from "/var/www/biopas-programa-paciente-form/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];